import AppDispatcher from '../AppDispatcher';
import Remote from '../Remote';

const QuoteHistoryStore = {

  _items: [],

  getAll: function () {
    return this._items;
  },

  getForSelect: function () {
    let options = [];

    for (let i = 0; i < this._items.length; i++) {
      options.push({
        value: this._items[i].Id,
        label: this._items[i].Name
      });
    }
    return options;
  },

  getMap: function () {
    let options = {};

    for (let i = 0; i < this._items.length; i++) {
      options[this._items[i].Id] = this._items[i].Name;
    }
    return options;
  },

  get: function (id) {
    for (let i = 0; i < this._items.length; i++) {
      if (this._items[i].Id === id) {
        return this._items[i];
      }
    }
    return null;
  },

  emitChange: function () {
    this.trigger(Constants.ActionTypes.QUOTE_HISTORY.UPDATE);
  },

  /**
   * @param {function} callback
   */
  addChangeListener: function (callback) {
    this.bind(Constants.ActionTypes.QUOTE_HISTORY.UPDATE, callback);
  },

  removeChangeListener: function (callback) {
    this.unbind(Constants.ActionTypes.QUOTE_HISTORY.UPDATE, callback);
  },

  handleDispatcher: function (action) {
    switch (action.actionType) {
      case Constants.ActionTypes.QUOTE_HISTORY.UPDATE:
        Remote.quoteHistoryGet(response => {
          this._items = response.Result.History;
          this.emitChange();
        });
        break;
      case Constants.ActionTypes.QUOTE_HISTORY.SET:
        this._items = action.items;
        this.emitChange();
        break;
    }
  }
};

MicroEvent.mixin(QuoteHistoryStore);

AppDispatcher.register(QuoteHistoryStore.handleDispatcher.bind(QuoteHistoryStore));

export default QuoteHistoryStore;



// WEBPACK FOOTER //
// ./src/js/Stores/QuoteHistoryStore.js